
import useAxios from './Api';
import constants from "./Constants";

const useAuthentication = () => {

    const instance = useAxios();

    // Login
    const login = async (postData, callback) => {
        try {
            var result = await instance.post(constants.urls.login, postData)
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Register
    const register = async (postData, callback) => {
        try {
            var result = await instance.post(constants.urls.register, postData)
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Get user profile
    const getUser = async (callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.users + '/me', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                }
            })
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Update user profile
    const updateUser = async (postData, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.put(constants.urls.users + '/me', postData, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                }
            })
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Get countries
    const getCountries = async (query = {}, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.misc + '/countries', {
                params: {
                    ...query
                }
            })
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Get verification types
    const getVerificationTypes = async (country_iso_code_2, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.users + '/identity', {
                params: {
                    country_shortcode: country_iso_code_2,
                    api_key: API_KEY,
                    email: EMAIL,
                }
            })
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Request verification code
    const requestVerificationCode = async (postData, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.post(constants.urls.users + '/verify', postData, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                }
            })
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Logout user
    const logout = async (callback) => {
        try {
            await constants.clearData();
            const currentEnv = constants.getCurrentEnvironment();
            if (currentEnv === 'SANDBOX') { constants.switchEnvironment('PRODUCTION', false); }
            return callback(null, { message: 'Logout successful!' });
        }
        catch (error) {
            return callback({
                message: 'Snap! Logout failed',
                errors: []
            }, null)
        }
    }

    // Refresh API key
    const refreshApiKey = async (postData, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.put(constants.apiUrls.prod_domain + constants.version + 'users' + '/settings', postData, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    identifier: postData?.identifier,
                }
            })
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    return {
        login, register, getUser, updateUser, getCountries, getVerificationTypes,
        requestVerificationCode, logout, refreshApiKey,
    };

}

export default useAuthentication